import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fieldPermission',
  pure: true
})
export class FieldPermissionPipe implements PipeTransform {

  transform(dynField: any, args?: any): any {
    let JsonObj = {
      "IsMandatory": dynField['IsMandatory'],
      "CanEdit": dynField['CanEdit']
    };
    let selected = JSON.stringify(JsonObj);
    return selected;
  }

}
